import copy from 'fast-copy';


export const eventReducer = (state, action) => {

  const newState = {};
  for (const key of Object.keys(action)) newState[key] = action[key];

  return copy({...state, ...newState});
};
